import { useState } from "react";

export function EyeSlash() {
  const [hovered, setHovered] = useState(false);

  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ cursor: "pointer" }}
      id="eye-slash-icon"
    >
      <path
        d="M4.08331 3.125L16.5833 16.875"
        stroke={hovered ? "#777882ff" : "#A4A5B1"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ transition: "all 0.3s ease-out" }}
      />
      <path
        d="M12.4354 12.3122C11.8221 12.8696 11.0126 13.1606 10.1847 13.1211C9.35692 13.0817 8.57868 12.715 8.02119 12.1018C7.46371 11.4885 7.17265 10.679 7.21203 9.85114C7.25141 9.02332 7.61802 8.24504 8.2312 7.6875"
        stroke={hovered ? "#777882ff" : "#A4A5B1"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ transition: "all 0.3s ease-out" }}
      />
      <path
        d="M6.11413 5.35938C2.92903 6.97231 1.58331 10.0005 1.58331 10.0005C1.58331 10.0005 4.08331 15.6249 10.3333 15.6249C11.7977 15.6366 13.2438 15.2993 14.5519 14.6409"
        stroke={hovered ? "#777882ff" : "#A4A5B1"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ transition: "all 0.3s ease-out" }}
      />
      <path
        d="M16.6309 13.2105C18.3342 11.685 19.0833 9.99965 19.0833 9.99965C19.0833 9.99965 16.5833 4.37404 10.3333 4.37404C9.792 4.37315 9.25155 4.41716 8.71751 4.50561"
        stroke={hovered ? "#777882ff" : "#A4A5B1"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ transition: "all 0.3s ease-out" }}
      />
      <path
        d="M10.9214 6.93066C11.5856 7.0582 12.1905 7.39766 12.6455 7.89811C13.1004 8.39857 13.3808 9.03303 13.4447 9.70635"
        stroke={hovered ? "#777882ff" : "#A4A5B1"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ transition: "all 0.3s ease-out" }}
      />
    </svg>
  );
}
